/* Maskavo · sacola (gaveta) ligada à Ajax API da Shopify.
   Portada do protótipo pdp-localhost (14/10/2026). Regras vêm de Configurações do tema ›
   "Maskavo · Sacola e regras" (JSON em snippets/mk-sacola.liquid).
   Expõe window.MKSacola = { abrir, fechar, adicionar, recarregar, cart, dados, util }. */
const D = JSON.parse(document.getElementById('mk-dados')?.textContent || '{}');
const R = D.regras || {};
const RAIZ = D.raiz && D.raiz !== '/' ? D.raiz.replace(/\/$/, '') + '/' : '/';
const CAT = D.catalogo || [];
const porHandle = Object.fromEntries(CAT.map((p) => [p.h, p]));

const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const brl = (c) => (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const ICO = {
  lixo: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>',
  mais: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
  menos: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M5 12h14"/></svg>',
  ok: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
  x: '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
  info: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.5v.5" stroke-linecap="round"/></svg>',
  pix: '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M5.283 18.36a3.505 3.505 0 0 0 2.493-1.032l3.6-3.6a.684.684 0 0 1 .946 0l3.613 3.613a3.504 3.504 0 0 0 2.493 1.032h.71l-4.56 4.56a3.647 3.647 0 0 1-5.156 0L4.85 18.36ZM18.428 5.627a3.505 3.505 0 0 0-2.493 1.032l-3.613 3.614a.67.67 0 0 1-.946 0l-3.6-3.6A3.505 3.505 0 0 0 5.283 5.64h-.434l4.573-4.572a3.646 3.646 0 0 1 5.156 0l4.559 4.559ZM1.068 9.422 3.79 6.699h1.492a2.483 2.483 0 0 1 1.744.722l3.6 3.6a1.73 1.73 0 0 0 2.443 0l3.614-3.613a2.482 2.482 0 0 1 1.744-.723h1.767l2.737 2.737a3.646 3.646 0 0 1 0 5.156l-2.736 2.736h-1.768a2.482 2.482 0 0 1-1.744-.722l-3.613-3.613a1.77 1.77 0 0 0-2.444 0l-3.6 3.6a2.483 2.483 0 0 1-1.744.722H3.791l-2.723-2.723a3.646 3.646 0 0 1 0-5.156"/></svg>',
  caminhao: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M2 6h11v10H2zM13 9h4.5L21 12.5V16h-8z"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
  cpf: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="11" r="2"/><path d="M6 16c.6-1.5 1.7-2 3-2s2.4.5 3 2M14 10h4M14 13h3" stroke-linecap="round"/></svg>',
};

/* ---------------- regras ---------------- */
const FAIXAS = (R.faixas || []).filter((f) => f.n > 0 && f.pct > 0).sort((a, b) => a.n - b.n);
const faixaAtual = (n) => [...FAIXAS].reverse().find((f) => n >= f.n) || null;
const proximaFaixa = (n) => FAIXAS.find((f) => n < f.n) || null;
const plural = (n, s, p) => (n === 1 ? s : p);

const CEP_UF = [
  [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'], [40000, 48999, 'BA'],
  [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'], [58000, 58999, 'PB'], [59000, 59999, 'RN'],
  [60000, 63999, 'CE'], [64000, 64999, 'PI'], [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'],
  [69000, 69299, 'AM'], [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
  [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'], [77000, 77999, 'TO'],
  [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'], [88000, 89999, 'SC'], [90000, 99999, 'RS'],
];
const ufDoCep = (cep) => {
  const pref = Number(String(cep).replace(/\D/g, '').slice(0, 5));
  return (CEP_UF.find(([a, b]) => pref >= a && pref <= b) || [])[2] || '';
};
const mascaraCep = (v) => { const d = String(v).replace(/\D/g, '').slice(0, 8); return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d; };
const DIAS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
function somaUteis(base, n) { const d = new Date(base); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) k++; } return d; }
const dataCurta = (d) => `${DIAS[d.getDay()]}, ${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
/* prazo mostrado = prazo dos Correios + folga (configuração do tema), para cobrir atraso */
function quando(dias) {
  if (!Array.isArray(dias) || !dias.length) return '';
  const folga = Math.max(0, Number(R.folga) || 0);
  const [a, b] = [Number(dias[0]) + folga, Number(dias[dias.length - 1]) + folga];
  const hoje = new Date(); hoje.setHours(12);
  const ini = dataCurta(somaUteis(hoje, a)), fim = dataCurta(somaUteis(hoje, b));
  const faixa = a === b ? `${a} ${plural(a, 'dia útil', 'dias úteis')}` : `${a} a ${b} dias úteis`;
  /* o checkout mostra só o prazo dos Correios; aqui o dia de preparo entra junto e fica dito */
  const preparo = folga ? `, com ${folga} ${plural(folga, 'dia', 'dias')} de preparo` : '';
  return `Chega ${ini === fim ? 'em ' + ini : 'entre ' + ini + ' e ' + fim} · ${faixa}${preparo}`;
}

/* Same Day L4 Flex (Worker maskavo-sameday): o nome da tarifa já traz o dia ("chega hoje", "chega amanhã"),
   então não soma folga de preparo nem prazo dos Correios */
const SAME_DAY = /^(Entrega (no mesmo dia|expressa)|Local Delivery|Entrega local)/i;
const nomeFrete = (o) => (o.sd ? 'Entrega no mesmo dia' : o.nome);
/* prazo do Same Day pelo relógio de SP (corte 11h, ter a sex, feriados): Worker maskavo-sameday /cobertura */
const SD_API = 'https://maskavo-sameday.maskavofactory.workers.dev';
let sdPrev = { cep: '', txt: '', hoje: false };
const cap = (t) => t.charAt(0).toUpperCase() + t.slice(1);
const sdQuando = () => (sdPrev.txt
  ? `${cap(sdPrev.txt)}${sdPrev.hoje ? '' : ' (pedido depois das 11h, fim de semana, segunda ou feriado)'} · motoboy L4 Flex`
  : 'Pago até 11h (ter a sex) chega no mesmo dia · motoboy L4 Flex');
async function sdPrevisao(cep) {
  if (sdPrev.cep === cep && sdPrev.txt) return;
  try { const j = await (await fetch(`${SD_API}/cobertura?cep=${cep}`)).json(); if (j.atende) sdPrev = { cep, txt: j.previsao, hoje: !!j.hoje }; } catch (_) {}
}

/* esconde opções lentas demais para cookie (prazo mostrado, já com folga, acima de R.prazoMax);
   se nenhuma couber, fica só a mais rápida */
function dentroDoPrazo(lista) {
  const max = Number(R.prazoMax) || 0;
  if (!max || !lista.length) return lista;
  const folga = Math.max(0, Number(R.folga) || 0);
  const fim = (o) => (Array.isArray(o.dias) && o.dias.length ? Number(o.dias[o.dias.length - 1]) + folga : 0);
  const ok = lista.filter((o) => fim(o) <= max);
  return ok.length ? ok : [lista.reduce((a, b) => (fim(b) < fim(a) ? b : a))];
}

/* estimativa dos Correios (cotações reais da loja, mesma tabela da PDP) para quando a Shopify não devolve os Correios */
function estimativaCorreios(cep, uf, n) {
  const T = { local: [['SEDEX', 994, 1, 2], ['PAC', 1545, 5, 6]], SP: [['Expresso', 967, 2, 3], ['SEDEX', 1490, 1, 2]], RJ: [['Expresso', 1327, 2, 4], ['SEDEX', 2885, 1, 3]],
    MG: [['Expresso', 1081, 2, 4], ['SEDEX', 2885, 1, 3]], ES: [['Expresso', 1450, 3, 4], ['SEDEX', 3090, 1, 3]] };
  const pref = Number(cep.slice(0, 5));
  const base = pref >= 13000 && pref <= 13149 ? T.local : T[uf] || [['SEDEX', 2885, 2, 3]];
  const extra = Math.max(0, n - 2) * 55;
  return base.map(([nome, preco, a, b]) => ({ nome, preco: preco + extra, dias: [a, b], est: true }));
}

const guarda = {
  get: (k) => { try { return localStorage.getItem(k) || ''; } catch (_) { return ''; } },
  set: (k, v) => { try { localStorage.setItem(k, v); } catch (_) {} },
};

/* ---------------- Ajax API ---------------- */
async function api(caminho, corpo) {
  const r = await fetch(RAIZ + caminho, corpo === undefined
    ? { headers: { Accept: 'application/json' }, credentials: 'same-origin' }
    : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify(corpo) });
  const j = await r.json().catch(() => ({}));
  if (!r.ok || j.status >= 400) { const e = new Error(j.description || j.message || 'Erro na sacola'); e.dados = j; e.http = r.status; throw e; }
  return j;
}

/* ---------------- estado otimista ----------------
   A tela nunca espera a Shopify. `base` é o último carrinho que a Shopify devolveu; `ops` são as
   intenções do cliente ainda não confirmadas, em ordem. O que a gaveta mostra (`cart`) é sempre
   base + ops reaplicadas. Toda conversa com o servidor passa por UMA fila de promessas, então a
   ordem das chamadas é a mesma dos toques. Quantidade tem debounce de 300 ms por linha. */
let base = null;
let cart = null;
let ops = [];
let fila = Promise.resolve();
let emVoo = 0, seqOp = 0;
let frete = { chave: '', cep: '', estado: 'nada', lista: [], erro: '' };
let freteEscolhido = guarda.get('mk-frete-nome');
let cupomErro = '';

const propsTxt = (p) => (p ? Object.keys(p).filter((k) => p[k] !== '' && p[k] != null).sort().map((k) => `${k}=${p[k]}`).join('&') : '');
const ident = (i) => `${i.variant_id ?? i.id}|${propsTxt(i.properties)}`;

function enfileirar(tarefa) {
  emVoo++; sync();
  const p = fila.then(tarefa);
  fila = p.catch(() => {}).finally(() => { emVoo--; sync(); });
  return p;
}
function sync() {
  if (!gav) return;
  const on = emVoo > 0 || ops.length > 0;
  gav.classList.toggle('is-sync', on);
  rolo?.setAttribute('aria-busy', on ? 'true' : 'false');
}

function poeQtd(l, q) {
  const antes = l.quantity || 1;
  l.quantity = q;
  l.original_line_price = l.original_price * q;
  l.final_line_price = l.final_price * q;
  l.line_price = l.final_line_price;
  l.total_discount = Math.max(0, (l.original_price - l.final_price) * q);
  if (Array.isArray(l.line_level_discount_allocations)) {
    l.line_level_discount_allocations = l.line_level_discount_allocations.map((a) => ({ ...a, amount: Math.round(a.amount * q / antes) }));
  }
}
function totais(c) {
  c.item_count = c.items.reduce((s, i) => s + i.quantity, 0);
  c.original_total_price = c.items.reduce((s, i) => s + i.original_line_price, 0);
  c.items_subtotal_price = c.items.reduce((s, i) => s + i.final_line_price, 0);
  const nivelCarrinho = (c.cart_level_discount_applications || []).reduce((s, d) => s + (d.total_allocated_amount || 0), 0);
  c.total_price = Math.max(0, c.items_subtotal_price - nivelCarrinho);
  c.total_discount = Math.max(0, c.original_total_price - c.total_price);
}
/* linha provisória (key 'tmp-…') feita com os dados do catálogo, enquanto a Shopify não confirma */
function linhaProvisoria(it, key) {
  const p = CAT.find((x) => x.id === it.id);
  const modelo = base.items.find((i) => i.variant_id === it.id);
  if (!p && !modelo) return null;
  const preco = modelo ? modelo.original_price : p.preco;
  const l = modelo
    ? { ...modelo, line_level_discount_allocations: [], final_price: modelo.original_price }
    : { id: it.id, variant_id: it.id, handle: p.h, product_title: p.nome, url: p.url, image: p.thumb, variant_title: '' };
  Object.assign(l, { key, tmp: true, properties: it.properties || null, original_price: preco, final_price: preco, price: preco, discounted_price: preco, line_level_discount_allocations: [] });
  poeQtd(l, it.quantity);
  return l;
}
function derivar() {
  if (!base) return null;
  if (!ops.length) return base;
  const c = { ...base, items: base.items.map((i) => ({ ...i })) };
  for (const op of ops) {
    if (op.tipo === 'add') {
      let pos = 0;
      op.itens.forEach((it, k) => {
        const id = `${it.id}|${propsTxt(it.properties)}`;
        const l = c.items.find((i) => ident(i) === id);
        if (l) poeQtd(l, l.quantity + it.quantity);
        else { const nova = linhaProvisoria(it, `tmp-${op.id}-${k}`); if (nova) c.items.splice(pos++, 0, nova); }
      });
    } else {
      const ls = c.items.filter((i) => ident(i) === op.alvo);
      if (!ls.length) continue;
      const [p, ...resto] = ls;
      c.items = c.items.filter((i) => !resto.includes(i) && (op.q > 0 || i !== p));
      if (op.q > 0) poeQtd(p, op.q);
    }
  }
  totais(c);
  return c;
}
function aplicar() {
  cart = derivar();
  atualizarBolha(); pintar(); sync();
  document.dispatchEvent(new CustomEvent('mk:sacola', { detail: { cart } }));
}
function confirma(op, novo) {
  if (novo) base = novo;
  ops = ops.filter((o) => o !== op);
  aplicar();
  cupomCaixa();
}

function recarregar() {
  return enfileirar(async () => {
    base = await api('cart.js');
    aplicar();
    cupomCaixa();
    if (pegaCep()) cotarSeMudou();
    return cart;
  });
}

function atualizarBolha() {
  const n = cart ? cart.item_count : 0;
  $$('cart-icon').forEach((c) => { try { c.renderCartBubble?.(n, false); } catch (_) {} });
  $$('[data-mk-conta]').forEach((el) => { el.textContent = n; el.classList.toggle('is-on', n > 0); });
}

/* Adicionar: o item aparece na hora (soma na linha igual ou entra no topo como provisório), a gaveta
   abre, e o POST vai pela fila. A promessa devolvida resolve true/false quando a Shopify responde. */
function adicionar(items, { abrir: abre = true } = {}) {
  const op = { tipo: 'add', id: ++seqOp, itens: items.map((it) => ({ ...it, id: +it.id, quantity: Math.max(1, +it.quantity || 1) })) };
  /* quantidades ainda no debounce vão antes, para a fila seguir a ordem dos toques */
  if (tMudar) enviarMudancas();
  ops.push(op);
  /* 22/10: sacola ainda não carregada (busca adiada para o ocioso) abria vazia até a Shopify responder.
     Agora os itens aparecem na hora sobre um carrinho provisório; o cart.js de verdade substitui logo depois */
  if (!base) { base = { items: [], item_count: 0, total_price: 0, original_total_price: 0, items_subtotal_price: 0, total_discount: 0, cart_level_discount_applications: [], provisorio: true }; }
  aplicar();
  if (abre) abrir();
  return enfileirar(async () => {
    try {
      /* 22/10: falha passageira (limite de pedidos da Shopify, rede, 5xx) tenta de novo antes de desistir;
         recusa de verdade (422: esgotado, quantidade) não repete */
      for (let k = 0; ; k++) {
        try { await api('cart/add.js', { items: op.itens }); window.mkEvento?.('sacola_adicionou'); break; }
        catch (e) { if (k >= 2 || e.http === 422) throw e; await new Promise((ok) => setTimeout(ok, 700 * (k + 1))); }
      }
      confirma(op, await api('cart.js'));
      if (pegaCep()) cotarSeMudou();
      return true;
    } catch (e) {
      toast(e.message);
      let novo = null;
      try { novo = await api('cart.js'); } catch (_) {}
      confirma(op, novo);
      return false;
    }
  });
}

/* Mudar quantidade: tela na hora, servidor 300 ms depois do último toque (em qualquer linha), tudo num pedido só.
   28/10: a Shopify troca a key de TODAS as linhas quando o desconto muda (sair um item tira o pedido da faixa de 5%).
   Mandar a key antiga dava erro e o item voltava. Agora a mudança mira a linha por variante + propriedades e a key
   é lida do carrinho mais recente na hora de enviar, num único cart/update.js com todas as mudanças. */
let tMudar = null;
function mudar(key, quantity) {
  const l = cart?.items.find((i) => i.key === key);
  if (!l) return;
  const alvo = ident(l);
  const total = cart.items.filter((i) => ident(i) === alvo).reduce((s, i) => s + i.quantity, 0);
  const q = Math.max(0, Math.min(99, total - l.quantity + Math.max(0, quantity | 0)));
  let op = ops.find((o) => o.tipo === 'mudar' && o.alvo === alvo && !o.enviado);
  if (op) op.q = q;
  else { op = { tipo: 'mudar', id: ++seqOp, alvo, q }; ops.push(op); }
  clearTimeout(tMudar); tMudar = setTimeout(enviarMudancas, 300);
  aplicar();
}
function enviarMudancas() {
  clearTimeout(tMudar); tMudar = null;
  const lote = ops.filter((o) => o.tipo === 'mudar' && !o.enviado);
  if (!lote.length) return;
  lote.forEach((o) => { o.enviado = true; });
  enfileirar(async () => {
    const pedido = () => {
      const up = {};
      lote.forEach((o) => (base?.items || []).filter((i) => ident(i) === o.alvo).forEach((i, k) => { up[i.key] = k ? 0 : o.q; }));
      return up;
    };
    let novo = null;
    for (let k = 0; k < 2 && !novo; k++) {
      const up = pedido();
      if (!Object.keys(up).length) break;
      try { novo = await api('cart/update.js', { updates: up }); }
      catch (e) { if (k) toast(e.message); else try { base = await api('cart.js'); } catch (_) {} }
    }
    if (!novo) try { novo = await api('cart.js'); } catch (_) {}
    if (novo) base = novo;
    ops = ops.filter((o) => !lote.includes(o));
    aplicar();
    cupomCaixa();
    if (pegaCep()) cotarSeMudou();
  });
}
function atualizar(corpo) {
  return enfileirar(async () => {
    try { base = await api('cart/update.js', corpo); aplicar(); }
    catch (e) { toast(e.message); }
  });
}

/* ---------------- frete ao vivo ---------------- */
const pegaCep = () => guarda.get('mk-cep');
async function cotarAoVivo(cep, uf) {
  const q = new URLSearchParams({ 'shipping_address[zip]': cep, 'shipping_address[country]': 'Brazil', 'shipping_address[province]': uf });
  try {
    const j = await api('cart/shipping_rates.json?' + q);
    if (Array.isArray(j.shipping_rates)) return j.shipping_rates;
  } catch (_) { /* tenta pelo caminho assíncrono */ }
  await fetch(RAIZ + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST', credentials: 'same-origin' });
  for (let k = 0; k < 8; k++) {
    await new Promise((ok) => setTimeout(ok, 700));
    const r = await fetch(RAIZ + 'cart/async_shipping_rates.json?' + q, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    const j = await r.json().catch(() => null);
    if (j && Array.isArray(j.shipping_rates)) return j.shipping_rates;
  }
  throw new Error('sem resposta');
}
let tCota;
function cotarSeMudou() {
  clearTimeout(tCota);
  tCota = setTimeout(cotar, 250);
}
async function cotar(rolar = false) {
  const cep = pegaCep();
  if (!cart || !cart.item_count || !cep) return;
  const chave = `${cep}|${cart.total_price}|${cart.item_count}`;
  if (frete.chave === chave && frete.estado !== 'erro') return;
  const limpo = cep.replace(/\D/g, '');
  const uf = ufDoCep(limpo);
  frete = { chave, cep, uf, estado: 'carregando', lista: [], erro: '' };
  if (limpo.length !== 8) { frete.estado = 'erro'; frete.erro = 'Digite os 8 números do CEP.'; pintar(); return; }
  if (!uf) { frete.estado = 'erro'; frete.erro = 'Não achamos esse CEP. Confere os números?'; pintar(); return; }
  pintar();
  try {
    let lista = await cotarAoVivo(mascaraCep(limpo), uf);
    const soLocal = (l) => l.length && l.every((o) => SAME_DAY.test(o.name));
    /* 22/10: CEP com entrega no mesmo dia às vezes volta só com ela (os Correios não responderam a tempo).
       O cliente escolhe: pergunta de novo e, se ainda faltar, mostra a estimativa dos Correios ao lado */
    if (soLocal(lista)) { await new Promise((ok) => setTimeout(ok, 900)); try { const l2 = await cotarAoVivo(mascaraCep(limpo), uf); if (l2.length > lista.length) lista = l2; } catch (_) {} }
    if (frete.chave !== chave) return;
    let opcoes = lista.map((o) => ({ nome: o.name, preco: Math.round(parseFloat(o.price) * 100), dias: o.delivery_days, sd: SAME_DAY.test(o.name) }));
    if (opcoes.length && opcoes.every((o) => o.sd)) opcoes = opcoes.concat(estimativaCorreios(limpo, uf, cart.item_count));
    /* o filtro de prazo vale só para os Correios: a entrega no mesmo dia aparece sempre junto das outras */
    frete.lista = opcoes.filter((o) => o.sd).concat(dentroDoPrazo(opcoes.filter((o) => !o.sd))).sort((a, b) => a.preco - b.preco);
    if (frete.lista.some((o) => o.sd)) await sdPrevisao(limpo);
    frete.estado = frete.lista.length ? 'ok' : 'erro';
    /* 03/11: só conta quando a própria pessoa pediu o frete (digitou/enviou o CEP). O recálculo sozinho de quem volta com CEP salvo
       e sacola cheia inflava o funil (sessões com 0 toques marcando frete). Manda junto o menor frete, para cruzar valor × desistência */
    if (rolar) window.mkEvento?.('frete_calculou', { uf, frete_min: frete.lista.length ? String(Math.round(Math.min(...frete.lista.map((o) => o.preco)) / 100)) : 'sem' });
    if (!frete.lista.length) frete.erro = 'Nenhuma entrega para esse CEP agora. Chama no WhatsApp que a gente resolve.';
  } catch (_) {
    frete.estado = 'erro';
    frete.erro = 'Não conseguimos calcular agora. O valor aparece no checkout, ou chama no WhatsApp.';
  }
  pintar();
  /* calculou e ainda não escolheu: leva as opções para a vista */
  if (rolar && frete.estado === 'ok' && !frete.lista.some((o) => o.nome === freteEscolhido)) mostraFretes();
}
function mostraFretes() {
  requestAnimationFrame(() => {
    const ul = $('.mk-fretes', rolo);
    if (!ul) return;
    /* 04/11: na página /cart quem rola é a janela, não a sacola */
    if (paginaCarrinho) { const q = ul.getBoundingClientRect(); if (q.top < 90 || q.bottom > innerHeight) ul.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); return; }
    const a = ul.getBoundingClientRect(), r = rolo.getBoundingClientRect();
    if (a.top < r.top || a.bottom > r.bottom) rolo.scrollBy({ top: a.top - r.top - 12, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
}

/* ---------------- caixa de 10 (27/10) ----------------
   Linhas com _caixa = "Caixa de 10 · XXXX" (sections/mk-caixa10.liquid) viram UM cartão na sacola. O grátis é o
   desconto automático "Compre 9, leve 1" da Shopify; enquanto ele não aparece no carrinho, a sacola calcula
   (o de menor valor de cada caixa), como faz com o desconto progressivo. */
const CX10 = /^Caixa de (\d+) · /;
const tamCaixa = (i) => { const m = CX10.exec(i.properties?._caixa || ''); return m ? +m[1] : 0; };
function agrupar(items) {
  const linhas = [], porCod = new Map();
  items.forEach((i) => {
    const t = tamCaixa(i);
    if (!t) { linhas.push({ tipo: 'item', i }); return; }
    const cod = i.properties._caixa;
    let g = porCod.get(cod);
    if (!g) { g = { tipo: 'caixa', cod, tam: t, itens: [] }; porCod.set(cod, g); linhas.push(g); }
    g.itens.push(i);
  });
  porCod.forEach((g) => {
    g.n = g.itens.reduce((s, i) => s + i.quantity, 0);
    g.m = Math.floor(g.n / g.tam);
    g.cheio = g.itens.reduce((s, i) => s + i.original_line_price, 0);
    g.final = g.itens.reduce((s, i) => s + i.final_line_price, 0);
    g.barato = g.itens.reduce((a, i) => (!a || i.original_price < a.original_price ? i : a), null);
    g.gratisLocal = g.m * (g.barato ? g.barato.original_price : 0);
  });
  /* 28/10: 10 ou mais cookies avulsos (PDP, coleção, vitrine) também viram uma caixa: um cartão só, com o grátis
     e a lista dos sabores. Caixas montadas (_caixa) continuam com o cartão delas. */
  const soltos = linhas.filter((l) => l.tipo === 'item' && porHandle[l.i.handle]);
  const nSoltos = soltos.reduce((s, l) => s + l.i.quantity, 0);
  if (nSoltos >= TAM_GRATIS) {
    const itens = soltos.map((l) => l.i);
    linhas.splice(0, linhas.length, ...linhas.filter((l) => !soltos.includes(l)));
    linhas.push({
      tipo: 'caixa', virtual: true, cod: 'sacola', tam: TAM_GRATIS, itens, n: nSoltos, m: Math.floor(nSoltos / TAM_GRATIS),
      cheio: itens.reduce((s, i) => s + i.original_line_price, 0), final: itens.reduce((s, i) => s + i.final_line_price, 0), gratisLocal: 0,
    });
  }
  /* a caixa vem primeiro, em destaque; os avulsos depois */
  return [...linhas.filter((l) => l.tipo === 'caixa'), ...linhas.filter((l) => l.tipo !== 'caixa')];
}
/* o grátis é o cupom CAIXA10 ("Compre 9, leve 1" da Shopify): a cada 10 cookies na sacola (caixa montada ou
   soltos) o de menor valor sai grátis. A sacola põe o cupom sozinha a partir de 10 e tira abaixo disso, e o
   checkout cobra o mesmo que a sacola mostra. */
const CUPOM_CAIXA = 'CAIXA10';
const TAM_GRATIS = 10;
const nCookies = (items) => (items || []).reduce((s, i) => s + (porHandle[i.handle] ? i.quantity : 0), 0);
/* os N cookies mais baratos da sacola (a Shopify dá o grátis no de menor valor) */
function gratisEstimado(items, n) {
  const precos = (items || []).filter((i) => porHandle[i.handle]).flatMap((i) => Array(i.quantity).fill(i.original_price)).sort((a, b) => a - b);
  return precos.slice(0, n).reduce((s, v) => s + v, 0);
}
/* 29/10: recompra (link do WhatsApp, ver snippets/mk-volta10.liquid): com window.MK_VOLTA a sacola mantém o VOLTA10
   (10% no pedido) no carrinho, junto com o CAIXA10 de sempre (a Shopify combina os dois: grátis primeiro, 10% no resto). */
const CUPOM_VOLTA = 'VOLTA10';
const voltaAtiva = () => !!window.MK_VOLTA;
let voltaTent = '', voltaN = 0, origemN = 0;
let cupomVoo = false;
function cupomCaixa() {
  if (!base || base.provisorio || ops.length || cupomVoo) return;
  const codigos = (base.discount_codes || []).map((d) => d.code);
  const temCod = (c) => codigos.some((x) => x.toUpperCase() === c);
  const quer = nCookies(base.items) >= TAM_GRATIS;
  let novos = quer === temCod(CUPOM_CAIXA) ? codigos
    : quer ? [...codigos, CUPOM_CAIXA] : codigos.filter((c) => c.toUpperCase() !== CUPOM_CAIXA);
  if (voltaAtiva() && !temCod(CUPOM_VOLTA)) {
    /* no máximo 2 tentativas por estado do carrinho (a Shopify pode recusar o código num carrinho vazio) */
    const est = String(base.item_count);
    if (voltaTent !== est) { voltaTent = est; voltaN = 0; }
    if (voltaN++ < 2) novos = [...novos, CUPOM_VOLTA];
  }
  /* exclusivo do link: fora do modo recompra o VOLTA10 sai do carrinho (quem digitou na mão ou herdou de outro navegador) */
  if (!voltaAtiva()) novos = novos.filter((c) => c.toUpperCase() !== CUPOM_VOLTA);
  const igual = novos.length === codigos.length && novos.every((c, i) => c === codigos[i]);
  /* rastreio: o pedido sai marcado "Origem: Recompra WhatsApp" (aparece em Detalhes adicionais do pedido no admin) */
  const precisaOrigem = voltaAtiva() && base.item_count > 0 && !(base.attributes && base.attributes.Origem) && origemN < 2;
  if (igual && !precisaOrigem) return;
  const corpo = {};
  if (!igual) corpo.discount = novos.join(',');
  if (precisaOrigem) {
    origemN++;
    corpo.attributes = { Origem: 'Recompra WhatsApp (VOLTA10)', 'Recompra: entrou pelo link em': guarda.get('mk-volta10-desde') || '' };
  }
  cupomVoo = true;
  atualizar(corpo).finally(() => { cupomVoo = false; recarregar(); });
}
const caixaShopify = () => (cart?.items || []).some((i) => (i.line_level_discount_allocations || []).some((a) => /leve 1|grátis|caixa10/i.test(a.discount_application?.title || '')));

/* ---------------- contas ---------------- */
function contas() {
  const n = cart.item_count;
  const cheio = cart.original_total_price;
  const atual = faixaAtual(n), prox = proximaFaixa(n);
  /* Desconto progressivo: quando os descontos automáticos da Shopify estão ligados, o carrinho já
     vem com o desconto e usamos o número dela. Enquanto não estão, a sacola calcula pela faixa. */
  const descShopify = cart.total_discount || 0;
  const caixas = agrupar(cart.items).filter((l) => l.tipo === 'caixa' && l.m > 0);
  const nCk = nCookies(cart.items);
  const gratisN = Math.floor(nCk / TAM_GRATIS);
  let descCaixa = caixaShopify() ? 0 : gratisEstimado(cart.items, gratisN);
  /* o "Compre 9, leve 1" não combina com o progressivo (desconto de pedido): a Shopify fica com o maior dos dois */
  const nivelPedido = (cart.cart_level_discount_applications || []).reduce((s, d) => s + (d.total_allocated_amount || 0), 0);
  let semNivel = false;
  if (descCaixa && nivelPedido && !voltaAtiva()) { if (nivelPedido >= descCaixa) descCaixa = 0; else semNivel = true; }
  /* com 10 ou mais o cookie grátis já vale: o progressivo não soma junto (o desconto da Shopify não combina) */
  const descProg = !descShopify && !gratisN && R.descAtivo && atual ? Math.round(cheio * atual.pct / 100) : 0;
  const desconto = descShopify - (semNivel ? nivelPedido : 0) + descProg + descCaixa;
  const produtos = cheio - desconto;
  /* 21/10: nada de entrega pré-marcada; a pessoa vê as opções e escolhe */
  const opcao = frete.estado === 'ok' ? (frete.lista.find((o) => o.nome === freteEscolhido) || null) : null;
  const valorFrete = opcao ? opcao.preco : null;
  const total = produtos + (valorFrete || 0);
  const pix = Math.round(total - produtos * (R.pix || 0) / 100);
  const elegivel = R.freteGratis > 0 && (!frete.uf || (R.ufsGratis || []).includes(frete.uf));
  return {
    n, cheio, produtos, desconto, descShopify, descProg, descCaixa, caixas, semNivel, nCk, gratisN, opcao, valorFrete, total, pix, elegivel, atual, prox,
    faltaMin: Math.max(0, (R.minimo || 0) - produtos),
    faltaGratis: Math.max(0, (R.freteGratis || 0) - produtos),
  };
}
function descontosAplicados(c) {
  const mapa = new Map();
  const nomeDesc = (t) => (/volta10/i.test(t) ? '10% OFF de volta' : t);
  if (!c?.semNivel) (cart.cart_level_discount_applications || []).forEach((d) => mapa.set(nomeDesc(d.title), (mapa.get(nomeDesc(d.title)) || 0) + (d.total_allocated_amount || 0)));
  cart.items.forEach((i) => (i.line_level_discount_allocations || []).forEach((a) => {
    const t0 = a.discount_application?.title || 'Desconto';
    const t = /caixa10|leve 1/i.test(t0) ? 'Cookie grátis a cada 10' : t0;
    mapa.set(t, (mapa.get(t) || 0) + a.amount);
  }));
  const lista = [...mapa.entries()].filter(([, v]) => v > 0);
  if (c && c.descProg) lista.push([`Desconto progressivo · ${c.atual.pct}%`, c.descProg]);
  if (c && c.descCaixa) lista.push([`${c.gratisN} ${plural(c.gratisN, 'cookie grátis', 'cookies grátis')} a cada 10`, c.descCaixa]);
  return lista;
}

/* ---------------- gaveta ---------------- */
const gav = document.getElementById('mk-sacola');
if (!gav) throw new Error('mk-sacola ausente');
const metas = $('.mk-sac__metas', gav), rolo = $('.mk-sac__rolo', gav), pe = $('.mk-sac__pe', gav);

/* página /cart: a mesma sacola, montada dentro da seção mk-carrinho, sempre aberta (sem fundo,
   sem trava de rolagem, sem fechar) */
const paginaCarrinho = document.querySelector('[data-mk-carrinho]');
if (paginaCarrinho) {
  paginaCarrinho.append(gav);
  paginaCarrinho.classList.add('is-montado');
  gav.classList.add('mk-sac--pagina', 'is-vis');
  gav.hidden = false;
  gav.removeAttribute('role'); gav.removeAttribute('aria-modal');
  $('.mk-sac__fundo', gav)?.remove();
  $('.mk-sac__x', gav)?.remove();
  const tit = $('.mk-sac__titulo', gav);
  if (tit) { const h1 = document.createElement('h1'); h1.className = tit.className; h1.id = tit.id; h1.innerHTML = tit.innerHTML; tit.replaceWith(h1); }
}

const MOBILE = matchMedia('(max-width: 989px)');
let yGuardado = 0, origemFoco = null;
function travar(liga) {
  const html = document.documentElement;
  if (liga) {
    html.setAttribute('scroll-lock', '');
    html.classList.add('mk-sac-aberta');
    if (MOBILE.matches) {
      yGuardado = (document.scrollingElement || html).scrollTop;
      Object.assign(document.body.style, { position: 'fixed', top: -yGuardado + 'px', left: '0', right: '0', width: '100%' });
    }
  } else {
    html.removeAttribute('scroll-lock');
    html.classList.remove('mk-sac-aberta');
    if (document.body.style.position === 'fixed') {
      Object.assign(document.body.style, { position: '', top: '', left: '', right: '', width: '' });
      (document.scrollingElement || html).scrollTop = yGuardado;
    }
  }
}
function medirTopo() {
  const cab = $('header-component') || $('#header-group') || $('header');
  const b = cab ? cab.getBoundingClientRect().bottom : 0;
  gav.style.setProperty('--mk-sac-topo', Math.min(160, Math.max(14, b + 10)) + 'px');
}
function abrir() {
  if (!cart || base?.provisorio) recarregar().catch(() => {}); /* busca adiada para o ocioso: se abrir antes, busca agora */
  if (paginaCarrinho || !gav.hidden) { pintar(); if (paginaCarrinho && pegaCep()) cotarSeMudou(); return; }
  origemFoco = document.activeElement;
  medirTopo(); pintar();
  $('.mk-toast')?.classList.remove('is-on');
  gav.hidden = false; travar(true);
  requestAnimationFrame(() => setTimeout(() => gav.classList.add('is-vis'), 20));
  setTimeout(() => $('.mk-sac__x', gav)?.focus(), 60);
  if (pegaCep()) cotarSeMudou();
}
function fechar() {
  if (paginaCarrinho) return;
  sugFeitas.clear();
  gav.classList.remove('is-vis');
  setTimeout(() => { gav.hidden = true; travar(false); origemFoco?.focus?.(); }, 360);
}
gav.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') { e.preventDefault(); fechar(); return; }
  if (e.key === 'Enter' && e.target.matches('.mk-item__qtd input')) { e.preventDefault(); e.target.blur(); return; }
  if (e.key !== 'Tab') return;
  const f = $$('a[href],button:not([disabled]),input:not([disabled]),textarea,select,[tabindex]:not([tabindex="-1"])', gav).filter((el) => el.offsetParent !== null);
  if (!f.length) return;
  const [p, u] = [f[0], f[f.length - 1]];
  if (e.shiftKey && document.activeElement === p) { e.preventDefault(); u.focus(); }
  else if (!e.shiftKey && document.activeElement === u) { e.preventDefault(); p.focus(); }
});
addEventListener('resize', () => { if (!gav.hidden) medirTopo(); });

/* O botão da sacola do cabeçalho (Horizon) e qualquer link para /cart abrem esta gaveta.
   Captura na window para rodar antes do on:click do Horizon e do carregador de página. */
const ehPaginaCarrinho = /\/cart\/?$/.test(location.pathname);
window.addEventListener('click', (e) => {
  if (ehPaginaCarrinho) return;
  const alvo = e.target.closest?.('[data-testid="cart-drawer-trigger"], [data-mk-abre-sacola], a[href="/cart"], a[href$="/cart"]');
  if (alvo && !gav.contains(alvo)) {
    e.preventDefault(); e.stopImmediatePropagation();
    abrir();
    return;
  }
  if (e.target.closest?.('[data-mk-fecha-sacola]')) fechar();
}, true);

/* "Quero esse" dos cards (formulário que levava para /cart): põe na sacola sem sair da página e abre
   a gaveta na hora — a linha aparece antes da Shopify responder. */
document.addEventListener('submit', (e) => {
  const f = e.target.closest?.('form.mk-cta__buy-now-form');
  if (!f) return;
  const id = +f.querySelector('[name="id"]')?.value;
  if (!id) return;
  e.preventDefault(); e.stopImmediatePropagation();
  adicionar([{ id, quantity: +f.querySelector('[name="quantity"]')?.value || 1 }]);
}, true);

/* Botões de compra do Horizon (cartões, quick add) avisam pelo evento padrão da Shopify. */
document.addEventListener('shopify:cart:lines-update', (e) => {
  const p = e.promise || Promise.resolve({});
  p.then(({ detail } = {}) => recarregar().then(() => { if (e.action === 'add' && !detail?.didError) abrir(); }))
    .catch(() => recarregar().catch(() => {}));
});

/* ---------------- pintar ----------------
   Ordem pensada para fechar a compra: régua de desconto (o motivo para pôr mais um) presa no
   topo, itens, "aproveite" com os sabores que faltam, opções (frete e presente) recolhidas, e o
   rodapé fixo com total, Pix e o botão. */
const ICO_CADEADO = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/></svg>';
const ICO_PRESENTE = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"><rect x="3.5" y="9" width="17" height="11" rx="1.5"/><path d="M2.5 9h19M12 9v11M12 9c-1.5-3.5-6-4.5-6-1.6C6 9 12 9 12 9zm0 0c1.5-3.5 6-4.5 6-1.6C18 9 12 9 12 9z"/></svg>';
const fotoDe = (h, fallback) => porHandle[h]?.recorte || fallback || porHandle[h]?.thumb || '';

/* ---------------- movimento ----------------
   Cada animação fica marcada com a hora em que começou. Como a gaveta é repintada inteira a cada
   mudança, a repintura reaplica a classe com animation-delay negativo (--dt) e o movimento continua
   de onde estava, em vez de recomeçar ou sumir. */
const marcas = new Map();
const marca = (k, atraso = 0) => marcas.set(k, performance.now() + atraso);
const idade = (k) => (marcas.has(k) ? performance.now() - marcas.get(k) : Infinity);
function anim(k, dur, nome) {
  const a = idade(k);
  return a < dur ? { c: ' ' + nome, s: `--dt:${Math.round(-a)}ms;` } : { c: '', s: '' };
}
/* Nada aqui lê layout (offsetHeight etc.) durante o toque: isso forçava o navegador a recalcular
   a página inteira e custava dezenas de ms. Alturas das linhas são lidas depois do quadro pintado. */
const MENOS_MOV = matchMedia('(prefers-reduced-motion: reduce)');
const alturas = new Map();
let tMedir = 0;
function medirLinhas() {
  cancelAnimationFrame(tMedir);
  tMedir = requestAnimationFrame(() => setTimeout(() => {
    $$('.mk-item[data-id]:not(.is-saindo)', rolo).forEach((el) => alturas.set(el.dataset.id, el.offsetHeight));
  }, 0));
}
const alturaDe = (el) => alturas.get(el.dataset.id) || 100;
function pulaConta(el) {
  if (MENOS_MOV.matches || !el.animate) return;
  el.animate([{ transform: 'none' }, { transform: 'scale(1.35) rotate(-8deg)', offset: 0.4 }, { transform: 'none' }], { duration: 450, easing: 'cubic-bezier(.22,1.06,.36,1)' });
}
const sugFeitas = new Set();
let ultimoQ = null, ultimoTotal = '', ultimaConta = null, tVazio = null;
const caixaPronta = () => CAT.slice(0, 4);

function blocoDesconto(c) {
  const n = c.nCk;
  /* recompra: uma barra só, com os 10% fixos no começo (já valem) e o cookie grátis no fim */
  if (voltaAtiva()) {
    const g = c.gratisN, resto = n % TAM_GRATIS, falta = TAM_GRATIS - resto;
    const msg = g
      ? `<span class="mk-hl">${g} grátis</span> no pedido. Mais <b>${falta}</b> e ganha o ${g + 1}º`
      : `Mais <b>${falta} ${plural(falta, 'cookie', 'cookies')}</b> e ganha <span class="mk-hl">1 grátis</span>`;
    return `<div class="mk-prog mk-prog--caixa mk-prog--volta">
      <p class="mk-prog__msg"><span>${msg}</span></p>
      <div class="mk-prog__trilho" role="progressbar" aria-valuemin="0" aria-valuemax="${TAM_GRATIS}" aria-valuenow="${resto}" aria-label="${n} cookies na sacola, 10% OFF já aplicado">
        <i class="mk-prog__cheio" style="--p:${(resto / TAM_GRATIS) * 100}%"></i>
        <span class="mk-prog__marco mk-prog__marco--volta is-ok" style="--x:0%"><span class="mk-prog__bolha">10% OFF ✓</span></span>
        <span class="mk-prog__marco mk-prog__marco--gratis" style="--x:100%"><span class="mk-prog__bolha">+1 grátis</span><small>${(g + 1) * TAM_GRATIS} cookies</small></span>
      </div>
    </div>`;
  }
  if (c.gratisN) {
    const falta = TAM_GRATIS - (n % TAM_GRATIS);
    const pct = ((n % TAM_GRATIS) / TAM_GRATIS) * 100;
    return `<div class="mk-prog mk-prog--caixa">
      <p class="mk-prog__msg"><span><span class="mk-hl">${c.gratisN} ${plural(c.gratisN, 'cookie grátis', 'cookies grátis')}</span> no pedido. Mais <b>${falta}</b> e ganha o ${c.gratisN + 1}º</span></p>
      <div class="mk-prog__trilho" role="progressbar" aria-valuemin="0" aria-valuemax="${TAM_GRATIS}" aria-valuenow="${n % TAM_GRATIS}" aria-label="${n} cookies na sacola">
        <i class="mk-prog__cheio" style="--p:${pct}%"></i>
        <span class="mk-prog__marco mk-prog__marco--gratis" style="--x:100%"><span class="mk-prog__bolha">+1 grátis</span><small>${(c.gratisN + 1) * TAM_GRATIS} cookies</small></span>
      </div>
    </div>`;
  }
  const faixas = R.descAtivo ? FAIXAS.filter((f) => f.n < TAM_GRATIS) : [];
  const marcosN = [...faixas.map((f) => ({ n: f.n, rot: `−${f.pct}%` })), { n: TAM_GRATIS, rot: '1 grátis', gratis: true }];
  const max = TAM_GRATIS;
  const prox = marcosN.find((m) => n < m.n);
  const atual = faixaAtual(n);
  const falta = prox.n - n;
  const premio = prox.gratis ? `<span class="mk-hl">1 cookie grátis</span>` : `<span class="mk-hl">${prox.rot.replace('−', '')} OFF</span> no pedido`;
  const msg = atual && atual.n < TAM_GRATIS
    ? `<span class="mk-hl">${atual.pct}% OFF</span> garantido. Mais <b>${falta}</b> e ganha ${premio}`
    : `Mais <b>${falta} ${plural(falta, 'cookie', 'cookies')}</b> e você ganha ${premio}`;
  const marcos = marcosN.map((m) => `
    <span class="mk-prog__marco ${n >= m.n ? 'is-ok' : ''}${m.gratis ? ' mk-prog__marco--gratis' : ''}" style="--x:${(m.n / max) * 100}%">
      <span class="mk-prog__bolha">${m.rot}</span><small>${m.n} cookies</small>
    </span>`).join('');
  return `<div class="mk-prog">
    <p class="mk-prog__msg">${msg}</p>
    <div class="mk-prog__trilho" role="progressbar" aria-valuemin="0" aria-valuemax="${max}" aria-valuenow="${Math.min(n, max)}" aria-label="${n} cookies na sacola">
      <i class="mk-prog__cheio" style="--p:${Math.min(100, (n / max) * 100)}%"></i>${marcos}
    </div>
  </div>`;
}

function avisoTopo(c) {
  if (c.faltaMin > 0) return `<p class="mk-sac__aviso">${ICO.info}<span>Pedido mínimo de ${brl(R.minimo)}: faltam <b>${brl(c.faltaMin)}</b></span></p>`;
  if (!R.freteGratis) return '';
  if (frete.uf && !c.elegivel) return '';
  if (c.faltaGratis <= 0) {
    if (frete.estado === 'ok' && !frete.lista.some((o) => o.preco === 0)) return '';
    return `<p class="mk-sac__aviso is-ok">${ICO.ok}<span><b>Frete grátis</b> para ${esc(R.regiaoGratis)}</span></p>`;
  }
  return `<p class="mk-sac__aviso">${ICO.caminhao}<span>Faltam <b>${brl(c.faltaGratis)}</b> para frete grátis (${esc(R.regiaoGratis)})</span></p>`;
}

function blocoSugestoes(c, modo) {
  const no = new Set((cart?.items || []).map((i) => i.handle));
  /* o que foi posto por aqui com a gaveta aberta continua no carrossel, com o ✓ */
  let lista = CAT.filter((p) => !no.has(p.h) || sugFeitas.has(p.h));
  if (!lista.length) lista = [...CAT];
  if (!lista.length) return '';
  const fechaMin = c && c.faltaMin > 0 ? lista.filter((p) => p.preco >= c.faltaMin && !no.has(p.h)).sort((a, b) => a.preco - b.preco)[0] : null;
  if (fechaMin) lista = [fechaMin, ...lista.filter((p) => p !== fechaMin)];
  const faltaGr = c ? TAM_GRATIS - (c.nCk % TAM_GRATIS) : 0;
  const titulo = modo === 'vazia' ? 'Ou escolha um por um'
    : c.faltaMin > 0 ? 'Feche o pedido mínimo'
    : faltaGr <= 4 ? `Mais ${faltaGr} e um sai grátis` : 'Mais um não faz mal';
  return `<section class="mk-up">
    <h3 class="mk-up__tit">${titulo}</h3>
    <div class="mk-up__trilho">${lista.map((p) => {
      const feito = sugFeitas.has(p.h) && no.has(p.h);
      const pula = anim('sug:' + p.h, 620, 'is-pula');
      return `
      <article class="mk-up__card${p === fechaMin ? ' is-destaque' : ''}${pula.c}" style="${pula.s}">
        ${p === fechaMin ? '<span class="mk-up__selo">Fecha o mínimo</span>' : ''}
        <button type="button" class="mk-up__foto" data-sug="${p.id}" tabindex="-1" aria-hidden="true"><img src="${esc(fotoDe(p.h))}" alt="" width="120" height="120" loading="lazy"></button>
        <span class="mk-up__nome">${esc(p.nome)}</span>
        <span class="mk-up__preco">${voltaAtiva() ? `<s>${brl(p.preco)}</s> ${brl(Math.round(p.preco * 0.9))}` : brl(p.preco)}</span>
        <button type="button" class="mk-up__mais${feito ? ' is-feito' : ''}${pula.c}" style="${pula.s}" data-sug="${p.id}" aria-label="${feito ? `${esc(p.nome)} na sacola. Pôr mais um` : `Pôr ${esc(p.nome)} na sacola`}">${feito ? ICO.ok : ICO.mais}</button>
      </article>`;
    }).join('')}</div>
  </section>`;
}

/* Sacola vazia: a caixa aberta se desenha sozinha, cai farelo, e o botão grande põe 4 sabores
   diferentes do catálogo (os 4 primeiros, 1 de cada) com um toque. */
function blocoVazio() {
  const caixa = caixaPronta();
  const soma = caixa.reduce((s, p) => s + p.preco, 0);
  const FARELOS = [[16, 141, 7, 1.15, 'r'], [30, 147, 5, 1.55, 'b'], [41, 143, 8, 1.35, 'r'], [62, 146, 6, 1.75, 'b'], [73, 141, 5, 2.05, 'r'], [86, 145, 7, 1.9, 'b'], [52, 149, 4, 2.35, 'r']];
  const farelos = FARELOS.map(([x, y, s, d, cor]) => `<i class="mk-vz__farelo mk-vz__farelo--${cor}" style="--x:${x}%;--y:${y}px;--s:${s}px;--d:${d}s"></i>`).join('');
  return `<div class="mk-vz">
    <div class="mk-vz__palco" aria-hidden="true">
      <span class="mk-vz__sombra"></span>
      <div class="mk-vz__desenho is-desenha" style="--n:1"></div>
      ${farelos}
    </div>
    <h3 class="mk-vz__tit">Só sobrou farelo.</h3>
    <p class="mk-vz__txt">A caixa tá aberta, olhando pra você, cheia de esperança e zero cookie.</p>
    ${caixa.length ? `<button type="button" class="mk-vz__monta" data-monta>
      <span class="mk-vz__monta-txt"><b>Monta uma caixa pra mim</b><small>${caixa.length} sabores diferentes, 1 de cada</small></span>
      <span class="mk-vz__monta-preco">${brl(soma)}</span>
    </button>
    <p class="mk-vz__quais">Na caixa: ${caixa.map((p) => esc(p.nome)).join(', ').replace(/, ([^,]*)$/, ' e $1')}.</p>` : ''}
  </div>${blocoSugestoes(null, 'vazia')}`;
}
function pintarVazia() {
  metas.hidden = true; pe.hidden = true;
  ultimoQ = new Map(); ultimoTotal = '';
  /* o último item recolhe antes de a caixa vazia aparecer */
  const vivas = $$('.mk-item:not(.is-saindo)', rolo);
  if (vivas.length) {
    vivas.forEach((el) => {
      el.style.setProperty('--h', alturaDe(el) + 'px'); el.style.setProperty('--dt', '0ms');
      el.classList.remove('is-novo'); el.classList.add('is-saindo'); el.inert = true;
    });
    clearTimeout(tVazio); tVazio = setTimeout(() => { tVazio = null; pintar(); }, 240);
    return;
  }
  if (tVazio || $('.mk-vz', rolo)) return;
  rolo.innerHTML = blocoVazio();
  requestAnimationFrame(() => { rolo.scrollTop = 0; });
  const alvo = $('.mk-vz__desenho', rolo);
  const tpl = document.getElementById('mk-vazio-desenho');
  if (tpl && tpl.content) alvo.append(tpl.content.cloneNode(true));
  else alvo.innerHTML = `<img src="${esc(D.vazia)}" alt="" width="150" height="150">`;
}

function pintar() {
  const n = cart ? cart.item_count : 0;
  $$('.mk-sac__conta', gav).forEach((el) => {
    el.textContent = n;
    if (cart && ultimaConta !== null && ultimaConta !== n) pulaConta(el);
  });
  if (!cart) return;
  ultimaConta = n;
  if (!cart.items.length) { pintarVazia(); return; }
  clearTimeout(tVazio); tVazio = null;
  const c = contas();
  metas.hidden = false; pe.hidden = false;
  /* régua de desconto: anda do valor antigo para o novo em vez de pular */
  const pAntes = $('.mk-prog__cheio', metas)?.style.getPropertyValue('--p');
  metas.innerHTML = blocoDesconto(c) + avisoTopo(c);
  const barra = $('.mk-prog__cheio', metas);
  if (barra && pAntes) {
    const pNovo = barra.style.getPropertyValue('--p');
    if (pNovo !== pAntes) { barra.style.setProperty('--p', pAntes); requestAnimationFrame(() => requestAnimationFrame(() => barra.style.setProperty('--p', pNovo))); }
  }

  /* o que entrou, o que mudou de quantidade, o que saiu */
  const qAgora = new Map();
  let kNovo = 0;
  const grupos = agrupar(cart.items);
  grupos.forEach((l) => {
    const id = l.tipo === 'caixa' ? 'caixa|' + l.cod : ident(l.i);
    const quantidade = l.tipo === 'caixa' ? l.n : l.i.quantity;
    qAgora.set(id, quantidade);
    if (!ultimoQ) return;
    if (!ultimoQ.has(id)) marca('novo:' + id, kNovo++ * 80);
    else if (ultimoQ.get(id) !== quantidade) marca('pop:' + id);
  });
  if (ultimoQ) ultimoQ.forEach((_, id) => { if (!qAgora.has(id)) marca('sai:' + id); });
  ultimoQ = qAgora;
  const antes = new Map();
  $$('.mk-item[data-id]', rolo).forEach((el, idx) => antes.set(el.dataset.id, { el, h: alturaDe(el), idx }));
  const eraVazia = !!$('.mk-vz', rolo);

  /* foco volta para o mesmo botão depois de repintar */
  const ae = document.activeElement;
  let volta = null;
  if (ae && rolo.contains(ae)) {
    const row = ae.closest('.mk-item');
    if (row && ae.matches('[data-acao]')) volta = { id: row.dataset.id, sel: `[data-acao="${ae.dataset.acao}"]` };
    else if (ae.matches('[data-sug]')) volta = { sel: `[data-sug="${ae.dataset.sug}"]` };
  }

  const shopCx = caixaShopify();
  const itens = grupos.map((l) => {
    if (l.tipo === 'caixa') return cartaoCaixa(l, shopCx, !shopCx && !c.descCaixa);
    const i = l.i;
    const p = porHandle[i.handle] || {};
    const caixa = i.properties?._caixa;
    const nome = p.nome || i.product_title;
    const id = ident(i);
    const nv = anim('novo:' + id, 720, 'is-novo');
    const pop = anim('pop:' + id, 380, 'is-pop');
    return `<div class="mk-item${nv.c}" style="${nv.s}" data-key="${esc(i.key)}" data-id="${esc(id)}" data-q="${i.quantity}">
      <a class="mk-item__foto" href="${esc(i.url)}"><img src="${esc(fotoDe(i.handle, i.image))}" alt="" width="72" height="72" loading="lazy"></a>
      <div class="mk-item__meio">
        <a class="mk-item__nome" href="${esc(i.url)}">${esc(nome)}</a>
        <div class="mk-item__det">${p.peso ? p.peso + ' g' : esc(i.variant_title || '')}${caixa ? ` · ${esc(caixa.split(' · ')[0])}` : ''}</div>
        <div class="mk-item__qtd">
          <button type="button" class="mk-toque" data-acao="menos" aria-label="${i.quantity === 1 ? 'Remover ' + esc(nome) : 'Tirar um'}">${i.quantity === 1 ? ICO.lixo : ICO.menos}</button>
          <input type="number" inputmode="numeric" min="0" max="99" value="${i.quantity}" class="${pop.c.trim()}" style="${pop.s}" aria-label="Quantidade de ${esc(nome)}" enterkeyhint="done">
          <button type="button" class="mk-toque" data-acao="mais" aria-label="Pôr mais um">${ICO.mais}</button>
        </div>
      </div>
      <div class="mk-item__preco${pop.c}" style="${pop.s}">${i.final_line_price < i.original_line_price ? `<s>${brl(i.original_line_price)}</s>` : ''}${brl(i.final_line_price)}</div>
    </div>`;
  }).join('');

  let opcoes = '';
  if (frete.estado === 'carregando') opcoes = '<p class="mk-msg">Calculando…</p>';
  else if (frete.estado === 'erro') opcoes = `<p class="mk-msg is-erro">${esc(frete.erro)}</p>`;
  else if (frete.estado === 'ok') {
    opcoes = `<ul class="mk-fretes" role="radiogroup" aria-label="Opções de entrega">${frete.lista.map((o) => `
      <li><label class="mk-frete ${o.preco === 0 ? 'mk-frete--gratis' : ''}">
        <span><input type="radio" name="mk-frete" value="${esc(o.nome)}" ${c.opcao && c.opcao.nome === o.nome ? 'checked' : ''}><b>${esc(nomeFrete(o))}</b></span>
        <span class="mk-frete__preco">${o.preco ? (o.est ? 'cerca de ' : '') + brl(o.preco) : 'Grátis'}</span>
        ${o.sd ? `<span class="mk-frete__quando">${esc(sdQuando())} · <a href="${RAIZ}pages/entrega-no-mesmo-dia?voltar=${encodeURIComponent(location.pathname)}">ver regras</a></span>` : quando(o.dias) ? `<span class="mk-frete__quando">${quando(o.dias)}</span>` : ''}</label></li>`).join('')}</ul>`;
  }
  const resumoFrete = c.opcao ? `${esc(nomeFrete(c.opcao))} · ${c.opcao.preco ? brl(c.opcao.preco) : 'grátis'}` : '';
  const freteNoPe = c.valorFrete === null && frete.estado !== 'ok';
  const formCep = (classe, dica) => `<form class="mk-cep__form ${classe}" data-cep-sacola data-mk-no-loader novalidate>
            <input class="mk-campo" name="cep" inputmode="numeric" autocomplete="postal-code" placeholder="${dica}" value="${esc(mascaraCep(pegaCep()))}" aria-label="CEP" maxlength="9" enterkeyhint="go">
            <button class="mk-cep__btn" type="submit"${frete.estado === 'carregando' ? ' disabled' : ''}>${frete.estado === 'carregando' ? 'Calculando…' : 'Calcular'}</button>
          </form>`;
  const ehPresente = !!(cart.attributes && cart.attributes['Presente']);

  const foco = document.activeElement && gav.contains(document.activeElement) ? document.activeElement.getAttribute('name') : null;
  const freteAberto = rolo.querySelector('[data-frete-det]')?.open ?? !pegaCep();
  rolo.innerHTML = `
    <div class="mk-itens">${itens}</div>
    <div class="mk-opcoes">
      <div class="mk-opc mk-opc--frete" data-frete-det>
        <div class="mk-opc__linha mk-opc__linha--fixa">${ICO.caminhao}<span class="mk-opc__t">Frete e prazo</span><span class="mk-opc__v">${resumoFrete || (freteNoPe ? 'digite o CEP aqui embaixo' : frete.estado === 'ok' ? 'escolha uma opção' : '')}</span></div>
        <div class="mk-opc__corpo">
          ${freteNoPe ? '' : formCep('', 'Outro CEP')}
          ${freteNoPe ? '' : opcoes}
          ${R.validade ? `<p class="mk-validade-linha">${esc(R.validade)}</p>` : ''}
        </div>
      </div>
      ${R.presente ? `<div class="mk-opc mk-opc--presente">
        <label class="mk-opc__linha">${ICO_PRESENTE}<span class="mk-opc__t">É presente?<small>Cartão escrito à mão, sem nota com preço</small></span>
          <input type="checkbox" class="mk-switch" data-presente ${ehPresente ? 'checked' : ''}></label>
        ${ehPresente ? `<textarea class="mk-sac__nota" data-nota-presente maxlength="240" placeholder="Escreva a mensagem do cartão">${esc(cart.note || '')}</textarea>` : ''}
      </div>` : ''}
    </div>
    ${blocoSugestoes(c)}`;
  /* trocar o miolo não mexe na rolagem; só zera ao sair da caixa vazia (no quadro, sem forçar layout) */
  if (eraVazia) requestAnimationFrame(() => { rolo.scrollTop = 0; });
  const focoCep = foco === 'cep';

  /* quem saiu volta por 220 ms, no mesmo lugar, só para recolher */
  const lista = $('.mk-itens', rolo);
  antes.forEach(({ el, h, idx }, id) => {
    if (qAgora.has(id)) return;
    const a = idade('sai:' + id);
    if (a >= 230) return;
    el.classList.remove('is-novo'); el.classList.add('is-saindo'); el.inert = true;
    if (!el.style.getPropertyValue('--h')) el.style.setProperty('--h', h + 'px');
    el.style.setProperty('--dt', Math.round(-a) + 'ms');
    lista.insertBefore(el, lista.children[idx] || null);
    setTimeout(() => el.remove(), 240 - a);
  });

  /* no quadro seguinte: focar dentro do toque forçava layout */
  if (volta) requestAnimationFrame(() => {
    const row = volta.id ? $$('.mk-item:not(.is-saindo)', rolo).find((r) => r.dataset.id === volta.id) : rolo;
    const alvo = row ? $(volta.sel, row) : ($('.mk-item:not(.is-saindo) [data-acao]', rolo) || $('.mk-sac__x', gav));
    alvo?.focus({ preventScroll: true });
  });

  const bloqueado = c.faltaMin > 0;
  const freteTxt = c.valorFrete === null ? (frete.estado === 'ok' ? '<button type="button" class="mk-res__escolher" data-ver-fretes>escolha a entrega ↑</button>' : '<span class="mk-res__cinza">pelo CEP acima</span>') : c.valorFrete === 0 ? 'Grátis' : brl(c.valorFrete);
  const totalTxt = brl(c.total);
  if (ultimoTotal && ultimoTotal !== totalTxt) marca('total');
  ultimoTotal = totalTxt;
  medirLinhas();
  const pulso = anim('total', 560, 'is-pulso');
  pe.innerHTML = `
    ${freteNoPe ? `<div class="mk-pe-cep">${formCep('mk-cep__form--pe', 'Seu CEP para ver o frete')}${frete.estado === 'erro' ? `<p class="mk-msg is-erro">${esc(frete.erro)}</p>` : ''}</div>` : ''}
    <dl class="mk-res">
      <dt>Subtotal · ${c.n} ${plural(c.n, 'cookie', 'cookies')}</dt><dd>${brl(c.cheio)}</dd>
      ${descontosAplicados(c).map(([t, v]) => `<dt class="is-desc">${esc(t)}</dt><dd class="is-desc">−${brl(v)}</dd>`).join('')}
      <dt>Frete${c.opcao ? ' · ' + esc(nomeFrete(c.opcao)) : ''}</dt><dd>${freteTxt}</dd>
    </dl>
    <div class="mk-res__total"><span>Total</span><b class="${pulso.c.trim()}" style="${pulso.s}">${totalTxt}</b></div>
    ${R.pix ? `<p class="mk-res__pix">${ICO.pix}<span>ou <b>${brl(c.pix)}</b> no Pix</span><span class="mk-pix__tag">${R.pix}% OFF</span></p>` : ''}
    <button class="mk-btn mk-btn--larga mk-sac__cta" type="button" data-checkout ${bloqueado ? 'disabled' : ''}>
      ${bloqueado ? `Faltam ${brl(c.faltaMin)} para o mínimo` : `Finalizar compra <span class="mk-btn__preco${pulso.c}" style="${pulso.s}">${totalTxt}</span>`}
    </button>
    <p class="mk-sac__seguro">${ICO_CADEADO}<span>Compra segura · Pix ou cartão${R.avisoCpf ? ' · tenha o CPF à mão' : ''}</span></p>`;
  if (focoCep) { const i = $('input[name="cep"]', gav); i?.focus({ preventScroll: true }); i?.setSelectionRange(99, 99); }
}

/* quantas unidades de cada sabor saíram grátis: lê o desconto da Shopify em cada linha; enquanto ele não vem,
   estima pelas de menor valor (a mesma escolha da Shopify). Devolve Map variant_id → unidades. */
const ehCaixa10 = (a) => /leve 1|grátis|caixa10/i.test(a.discount_application?.title || '');
function gratisPorSabor(itens, m) {
  const mapa = new Map();
  itens.forEach((i) => {
    const v = (i.line_level_discount_allocations || []).filter(ehCaixa10).reduce((s, a) => s + a.amount, 0);
    const u = i.original_price ? Math.round(v / i.original_price) : 0;
    if (u) mapa.set(i.variant_id, (mapa.get(i.variant_id) || 0) + u);
  });
  if (!mapa.size && m) {
    itens.flatMap((i) => Array(i.quantity).fill(i)).sort((a, b) => a.original_price - b.original_price).slice(0, m)
      .forEach((i) => mapa.set(i.variant_id, (mapa.get(i.variant_id) || 0) + 1));
  }
  return mapa;
}
function seloGratis(itens, mapa, m) {
  const nomes = [...mapa.keys()].map((v) => { const i = itens.find((x) => x.variant_id === v); return porHandle[i?.handle]?.nome || i?.product_title || ''; });
  const total = [...mapa.values()].reduce((s, q) => s + q, 0) || m;
  if (nomes.length === 1) return `${total > 1 ? total + ' ' : ''}${esc(nomes[0])} grátis`;
  return `${total} cookies grátis: ${esc(nomes.join(', ').replace(/, ([^,]*)$/, ' e $1'))}`;
}

/* caixa formada pelos avulsos: a caixa desenhada, o grátis e a lista dos sabores, cada um com − / + */
function cartaoCaixaSacola(g, shopCx) {
  const id = 'caixa|' + g.cod;
  const nv = anim('novo:' + id, 720, 'is-novo');
  const pop = anim('pop:' + id, 380, 'is-pop');
  const vagas = g.itens.flatMap((i) => Array(i.quantity).fill(i)).slice(0, g.tam)
    .map((i) => `<i><img src="${esc(fotoDe(i.handle, i.image))}" alt="" width="40" height="40" loading="lazy"></i>`).join('');
  const final = shopCx ? g.final : g.cheio;
  const titulo = g.n === g.tam ? `Caixa de ${g.tam} cookies` : `Caixa com ${g.n} cookies`;
  const falta = g.tam - (g.n % g.tam);
  /* a Shopify separa a unidade grátis numa linha própria: junta por sabor (o − / + mexe na linha maior) */
  const porSabor = new Map();
  g.itens.forEach((i) => {
    const x = porSabor.get(i.variant_id);
    if (!x) porSabor.set(i.variant_id, { ...i });
    else { if (i.quantity > x.maior) { x.key = i.key; x.maior = i.quantity; } x.quantity += i.quantity; }
    if (!x) porSabor.get(i.variant_id).maior = i.quantity;
  });
  const gratis = gratisPorSabor(g.itens, g.m);
  const sabores = [...porSabor.values()].sort((a, b) => b.quantity - a.quantity).map((i) => {
    const nome = porHandle[i.handle]?.nome || i.product_title;
    const gq = gratis.get(i.variant_id) || 0;
    return `<li class="mk-cx__sabor${gq ? ' is-gratis' : ''}" data-key="${esc(i.key)}">
        <span class="mk-cx__sabor-n">${esc(nome)}${gq ? `<em class="mk-cx__sabor-g">${gq < i.quantity ? gq + ' grátis' : 'grátis'}</em>` : ''}</span>
        <span class="mk-cx__sabor-q">
          <button type="button" class="mk-toque" data-acao="menos" aria-label="${i.quantity === 1 ? 'Remover ' + esc(nome) : 'Tirar um ' + esc(nome)}">${i.quantity === 1 ? ICO.lixo : ICO.menos}</button>
          <b>${i.quantity}</b>
          <button type="button" class="mk-toque" data-acao="mais" aria-label="Mais um ${esc(nome)}">${ICO.mais}</button>
        </span>
      </li>`;
  }).join('');
  return `<div class="mk-item mk-item--caixa mk-item--caixa-sacola${nv.c}" style="${nv.s}" data-key="${esc(g.itens[0].key)}" data-id="${esc(id)}" data-q="${g.n}">
      <div class="mk-cx__vis" aria-hidden="true" style="--cols:5"><span class="mk-cx__tampa">Maskavo</span><span class="mk-cx__bandeja">${vagas}</span></div>
      <div class="mk-item__meio">
        <span class="mk-item__nome">${esc(titulo)}</span>
        <span class="mk-cx__gratis">${ICO.ok}${seloGratis(g.itens, gratis, g.m)}</span>
        ${g.n % g.tam ? `<span class="mk-cx__aviso">Mais ${falta} e ganha o ${g.m + 1}º grátis</span>` : ''}
      </div>
      <div class="mk-item__preco${pop.c}" style="${pop.s}">${final < g.cheio ? `<s>${brl(g.cheio)}</s>` : ''}${brl(final)}</div>
      <ul class="mk-cx__sabores" role="list">${sabores}</ul>
    </div>`;
}

/* a caixa fechada: a caixa desenhada com os recortes, o nome, um resumo curto dos sabores e o grátis */
function cartaoCaixa(g, shopCx, semGratis) {
  if (g.virtual) return cartaoCaixaSacola(g, shopCx);
  const id = 'caixa|' + g.cod;
  const nv = anim('novo:' + id, 720, 'is-novo');
  const pop = anim('pop:' + id, 380, 'is-pop');
  const m = Math.max(1, g.m);
  const sabores = [...g.itens].sort((a, b) => b.quantity - a.quantity)
    .map((i) => `${esc(porHandle[i.handle]?.nome || i.product_title)}${i.quantity / m > 1 ? ` ×${Math.round(i.quantity / m)}` : ''}`);
  const resumo = sabores.length > 4 ? `${sabores.slice(0, 4).join(', ')} e mais ${sabores.length - 4}` : sabores.join(', ').replace(/, ([^,]*)$/, ' e $1');
  const vagas = g.itens.flatMap((i) => Array(Math.max(1, Math.round(i.quantity / m))).fill(i)).slice(0, g.tam)
    .map((i) => `<i><img src="${esc(fotoDe(i.handle, i.image))}" alt="" width="40" height="40" loading="lazy"></i>`).join('');
  const final = shopCx ? g.final : g.cheio;
  const titulo = g.m > 1 ? `${g.m} caixas de ${g.tam} cookies` : `Caixa de ${g.tam} cookies`;
  const incompleta = g.n % g.tam !== 0;
  return `<div class="mk-item mk-item--caixa${nv.c}" style="${nv.s}" data-key="${esc(g.itens[0].key)}" data-id="${esc(id)}" data-caixa="${esc(g.cod)}" data-q="${g.n}">
      <div class="mk-cx__vis" aria-hidden="true" style="--cols:${Math.ceil(g.tam / 2)}"><span class="mk-cx__tampa">Maskavo</span><span class="mk-cx__bandeja">${vagas}</span></div>
      <div class="mk-item__meio">
        <span class="mk-item__nome">${esc(titulo)}</span>
        <p class="mk-cx__desc">${g.m > 1 ? 'Cada uma com ' : ''}${resumo}</p>
        ${g.m && !semGratis ? `<span class="mk-cx__gratis">${ICO.ok}${seloGratis(g.itens, gratisPorSabor(g.itens, g.m), g.m)}</span>` : ''}
        ${incompleta ? `<span class="mk-cx__aviso">O grátis vale a cada caixa de ${g.tam} completa</span>` : ''}
        <div class="mk-item__qtd mk-cx__qtd">
          <button type="button" class="mk-toque" data-acao="cx-menos" aria-label="${m <= 1 ? 'Remover a caixa' : 'Tirar uma caixa'}">${m <= 1 ? ICO.lixo : ICO.menos}</button>
          <span class="mk-cx__m${pop.c}" style="${pop.s}" aria-label="${m} ${plural(m, 'caixa', 'caixas')}">${m}</span>
          <button type="button" class="mk-toque" data-acao="cx-mais" aria-label="Mais uma caixa igual">${ICO.mais}</button>
        </div>
      </div>
      <div class="mk-item__preco${pop.c}" style="${pop.s}">${final < g.cheio ? `<s>${brl(g.cheio)}</s>` : ''}${brl(final)}</div>
    </div>`;
}
/* − / + da caixa: muda todas as linhas dela na mesma proporção (mais uma caixa igual, ou tira uma) */
function mudarCaixa(cod, delta) {
  const g = agrupar(cart?.items || []).find((l) => l.tipo === 'caixa' && l.cod === cod);
  if (!g) return;
  const m = Math.max(1, g.m), novo = Math.max(0, m + delta);
  g.itens.forEach((i) => mudar(i.key, Math.round((i.quantity / m) * novo)));
}

/* ---------------- eventos da gaveta ---------------- */
gav.addEventListener('click', (e) => {
  const b = e.target.closest('[data-acao]');
  if (b && b.dataset.acao.startsWith('cx-')) {
    const linha = b.closest('.mk-item');
    if (linha && !linha.classList.contains('is-saindo')) mudarCaixa(linha.dataset.caixa, b.dataset.acao === 'cx-mais' ? 1 : -1);
    return;
  }
  if (b) {
    const cartao = b.closest('.mk-item'), linha = b.closest('[data-key]');
    if (!linha || !cartao || cartao.classList.contains('is-saindo')) return;
    const l = cart?.items.find((i) => i.key === linha.dataset.key);
    if (l) mudar(l.key, b.dataset.acao === 'mais' ? l.quantity + 1 : l.quantity - 1);
    return;
  }
  const s = e.target.closest('[data-sug]');
  if (s) {
    const p = CAT.find((x) => x.id === +s.dataset.sug);
    if (p) { sugFeitas.add(p.h); marca('sug:' + p.h); }
    adicionar([{ id: +s.dataset.sug, quantity: 1 }], { abrir: false });
    return;
  }
  if (e.target.closest('[data-ver-fretes]')) { mostraFretes(); return; }
  if (e.target.closest('[data-ir-cep]')) {
    const det = $('[data-frete-det]', rolo);
    if (det) det.open = true;
    const i = $('input[name="cep"]', rolo);
    i?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    setTimeout(() => i?.focus({ preventScroll: true }), 350);
    return;
  }
  if (e.target.closest('[data-monta]')) {
    adicionar(caixaPronta().map((p) => ({ id: p.id, quantity: 1 })), { abrir: false });
    return;
  }
  const tc = e.target.closest('[data-tira-cupom]');
  if (tc) {
    const resto = (cart.discount_codes || []).map((d) => d.code).filter((x) => x !== tc.dataset.tiraCupom);
    /* tirou o VOLTA10 na mão: sai do modo recompra (a sacola para de repor o cupom) */
    if (tc.dataset.tiraCupom.toUpperCase() === CUPOM_VOLTA) { window.MK_VOLTA = 0; document.documentElement.classList.remove('mk-volta'); guarda.set('mk-volta10', ''); }
    cupomErro = ''; atualizar({ discount: resto.join(',') }); return;
  }
  if (e.target.closest('[data-checkout]')) {
    const btn = e.target.closest('[data-checkout]');
    btn.disabled = true; btn.textContent = 'Indo para o pagamento…';
    window.mkEvento?.('checkout_iniciou');
    // carrinho novo se o cliente volta ao checkout depois de um tempo (assets/mk-checkout-novo.js)
    Promise.resolve(window.mkPrepararCheckout?.()).finally(() => { location.href = RAIZ + 'checkout'; });
  }
});
gav.addEventListener('change', (e) => {
  if (e.target.matches('.mk-item__qtd input')) {
    const linha = e.target.closest('.mk-item');
    const l = cart?.items.find((i) => i.key === linha?.dataset.key);
    const pedido = parseInt(e.target.value, 10) || 0;
    const q = Math.max(0, Math.min(99, pedido));
    if (pedido > 99) toast('Até 99 de cada sabor por pedido. Para mais, chama no WhatsApp.');
    if (l && q !== l.quantity) mudar(l.key, q);
  } else if (e.target.name === 'mk-frete') {
    freteEscolhido = e.target.value; guarda.set('mk-frete-nome', freteEscolhido); pintar();
  } else if (e.target.matches('[data-presente]')) {
    atualizar({ attributes: { Presente: e.target.checked ? 'Sim' : '' }, ...(e.target.checked ? {} : { note: '' }) })
      .then(() => $('[data-nota-presente]', gav)?.focus());
  }
});
let tNota;
gav.addEventListener('input', (e) => {
  if (e.target.matches('[data-nota-presente]')) {
    clearTimeout(tNota);
    const v = e.target.value;
    /* sem repintar: o cliente está digitando no cartão */
    tNota = setTimeout(() => enfileirar(() => api('cart/update.js', { note: v }).then((c) => { base = c; cart = derivar(); }).catch(() => {})), 600);
  }
  if (e.target.name === 'cep') {
    e.target.value = mascaraCep(e.target.value);
    /* 25/10: com os 8 números o frete calcula sozinho (no Clarity, gente tocava em Calcular duas vezes) */
    const limpo = e.target.value.replace(/\D/g, '');
    /* 04/11: com os 8 números, calcula e fecha o teclado, para o resultado do frete aparecer inteiro */
    if (limpo.length === 8 && limpo !== (pegaCep() || '').replace(/\D/g, '')) { const f = e.target.form; e.target.blur(); f?.requestSubmit(); }
  }
});
gav.addEventListener('submit', (e) => {
  e.preventDefault();
  if (e.target.matches('[data-cep-sacola]')) {
    guarda.set('mk-cep', e.target.cep.value);
    freteEscolhido = ''; frete.chave = '';
    cotar(true); return;
  }
  if (e.target.matches('[data-cupom]')) {
    const cod = e.target.cupom.value.trim().toUpperCase();
    if (!cod) { cupomErro = 'Digite o código do cupom.'; pintar(); return; }
    if (cod === CUPOM_VOLTA && !voltaAtiva()) { cupomErro = 'Esse desconto é exclusivo do link que enviamos pelo WhatsApp.'; pintar(); return; }
    const todos = [...new Set([...(cart.discount_codes || []).map((d) => d.code), cod])];
    cupomErro = '';
    atualizar({ discount: todos.join(',') }).then(() => {
      const d = (cart.discount_codes || []).find((x) => x.code.toUpperCase() === cod);
      if (!d || !d.applicable) { cupomErro = `O cupom ${cod} não vale para esta sacola. Confere as letras?`; pintar(); }
      else toast('Cupom aplicado');
    });
  }
});

/* ---------------- toast ---------------- */
let tToast;
function toast(msg) {
  let t = $('.mk-toast'); if (!t) { t = document.createElement('div'); t.className = 'mk-toast'; t.setAttribute('role', 'status'); document.body.append(t); }
  t.textContent = msg; t.classList.add('is-on'); clearTimeout(tToast); tToast = setTimeout(() => t.classList.remove('is-on'), 2800);
}

window.MKSacola = {
  abrir, fechar, adicionar, recarregar, toast,
  get cart() { return cart; },
  dados: D,
  util: { brl, esc, ICO, ufDoCep, mascaraCep, quando, dentroDoPrazo, faixaAtual, proximaFaixa, FAIXAS, guarda },
};
document.dispatchEvent(new CustomEvent('mk:sacola-pronta'));
/* 22/10 velocidade: a sacola busca o carrinho depois do carregamento, com a thread livre (o número do ícone já vem
   pronto do servidor). Se a pessoa abrir ou adicionar antes, abrir()/adicionar() já buscam na hora. */
(function () {
  const vai = () => recarregar().catch(() => {});
  const ocioso = () => ('requestIdleCallback' in window ? requestIdleCallback(vai, { timeout: 2500 }) : setTimeout(vai, 400));
  if (paginaCarrinho) vai(); /* na página /cart a sacola é o conteúdo: carrega já */
  else if (document.readyState === 'complete') ocioso(); else addEventListener('load', ocioso, { once: true });
})();
